module.exports = __webpack_public_path__ + "static/media/twitter.5ce37dd5.svg";